<div class="row">
    <div class="col-sm-4">
        <div class="row">
            <div class="col">
                <label><strong>Customer 3x3:</strong></label>
                <input class="form-control" type="text" [(ngModel)]="selectedCustomer.customerCode" disabled />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Name:</strong></label>
                <input class="form-control" type="text" [(ngModel)]="selectedCustomer.name" [disabled]="isLocked" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Address:</strong></label>
                <input class="form-control" type="text" [(ngModel)]="selectedCustomer.address1" maxlength="100" [disabled]="!isCRMAdmin || isLocked" required />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Address 2:</strong></label>
                <input class="form-control" type="text" [(ngModel)]="selectedCustomer.address2" maxlength="100" [disabled]="!isCRMAdmin || isLocked" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>City:</strong></label>
                <city-state-zip-dropdown [parentForm]="customerForm"
                                         [ctrlName]="'cityCtrl'"
                                         [placeholder]="'Select a City'"
                                         [cityID]="selectedCustomer.cityId"
                                         (citySelected)="citySTChanged($event)"
                                         [defaultCity]="defaultCustomerCity"
                                         [isRequired]="true"
                                         [isDisabled]="!isCRMAdmin || isLocked"></city-state-zip-dropdown>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label class="fw-bold">Internal Tracking Email</label>
                <input type="text" class="form-control" [(ngModel)]="selectedCustomer.internalTrackingEmail" />
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Website:</strong></label>
                <a href="{{selectedCustomer.website != null && selectedCustomer.website.toLowerCase().startsWith('http') ? selectedCustomer.website : 'http://' + selectedCustomer.website}}" target="_blank">{{selectedCustomer.website}}</a>
                <input type="text" class="form-control" [(ngModel)]="selectedCustomer.website" [disabled]="isLocked" />
            </div>
        </div>
    </div>
    <div class="col-sm-3">
        <div class="row">
            <div class="col">
                <input type="checkbox" name="billToInd" style="transform:scale(1.5);margin:5px;" [(ngModel)]="selectedCustomer.billToInd" [checked]="selectedCustomer.billToInd" [disabled]="isLocked">
                <label for="billToInd" class="fw-bold">Bill To</label>
            </div>
            <div class="col">
                <input type="checkbox" name="shipperInd" style="transform:scale(1.5);margin:5px;" [(ngModel)]="selectedCustomer.shipperInd" [checked]="selectedCustomer.shipperInd" [disabled]="isLocked">
                <label for="shipperInd" class="fw-bold">Shipper</label>
            </div>
            <div class="col">
                <input type="checkbox" name="consigneeInd" style="transform:scale(1.5);margin:5px;" [(ngModel)]="selectedCustomer.consigneeInd" [checked]="selectedCustomer.consigneeInd" [disabled]="isLocked">
                <label for="consigneeInd" class="fw-bold">Consignee</label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" name="activeInd" style="transform:scale(1.5);margin:5px;" [(ngModel)]="selectedCustomer.activeInd" [checked]="selectedCustomer.activeInd" [disabled]="isLocked">
                <label for="activeInd" class="fw-bold">Active</label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" name="retiredInd" style="transform:scale(1.5);margin:5px;" [(ngModel)]="selectedCustomer.retiredInd" [checked]="selectedCustomer.retiredInd" [disabled]="isLocked">
                <label for="retiredInd" class="fw-bold">Retired</label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Freight Spend:</strong></label><br />
                <kendo-numerictextbox [min]="0" [(ngModel)]="selectedCustomer.freightSpend" [disabled]="isLocked"></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Credit Limit:</strong></label><br />
                <kendo-numerictextbox [min]="0" [(ngModel)]="selectedCustomer.creditLimitAmount" [disabled]="!isCRMAdmin || isLocked"></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Initiatives:</strong></label><br />
                <kendo-multiselect [data]="initiativeList"
                                   [(ngModel)]="initiativeIDList"
                                   [textField]="'title'"
                                   [valuePrimitive]="true"
                                   [valueField]="'customerInitiativeID'"
                                   [popupSettings]="{ appendTo: 'component' }"
                                   [disabled]="isLocked">
                </kendo-multiselect>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <input type="checkbox" name="isParent" style="transform:scale(1.5);margin:5px;" [(ngModel)]="isParent" [checked]="selectedCustomer.parent == 'Y'" [disabled]="isLocked">
                <label for="isParent" class="fw-bold">Parent</label>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Monthly Revenue Base Line:</strong></label><br />
                <kendo-numerictextbox [min]="0" [(ngModel)]="selectedCustomer.monthlyNetRevenueBaseLine" [disabled]="isLocked"></kendo-numerictextbox>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Industry:</strong></label><br />
                <kendo-dropdownlist [data]="industries"
                                    [textField]="'description'"
                                    [valueField]="'industryId'"
                                    [valuePrimitive]="true"
                                    [(ngModel)]="selectedCustomer.industryId"
                                    [disabled]="selectedCustomer.retiredInd == true || isLocked"
                                    [ngModelOptions]="{standalone: true}"></kendo-dropdownlist>
            </div>
        </div>
    </div>
    <div class="col">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Parent Company</label>
                        <customer-dropdown [parentForm]="customerForm"
                                           [ctrlName]="'parentCustomerCtrl'"
                                           [placeholder]="'Enter Code'"
                                           [lookupType]="'parent'"
                                           (customerSelected)="onCustomerChange($event, 'parentCustomerCtrl')"
                                           [isDisabled]="isLocked"></customer-dropdown>
                    </div>
                </div>
                <div class="row" *ngIf="(parentCustomer | json) != '{}'">
                    <div class="col">
                        <a target="_blank" [routerLink]="['/customer-detail', parentCustomer.customerCode]" tabindex="-1">{{parentCustomer.customerName}}</a><br />
                        <a target="_blank" [routerLink]="['/customer-detail', parentCustomer.customerCode]" tabindex="-1">{{parentCustomer.customerCode}}</a><br />
                        {{parentCustomer.address1}}<br />
                        {{parentCustomer.cityStateZip}}<br />
                        <i class="fas fa-globe"></i> {{parentCustomer.timeZoneName}}
                    </div>
                    <div class="col-sm-1">
                        <button type="button" class="btn btn-danger float-right" title="Remove Parent" (click)="removeParent()">
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
            <div class="col" *ngIf="isLocked">
                <h2 class="text-danger">* Profile Locked</h2>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>CRM Notes:</strong></label>
                <textarea rows="5" class="form-control" [(ngModel)]="crmNotes.commentText" (focusout)="saveComment(crmNotes, 'crmNotes')"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <label><strong>Operational Notes:</strong></label>
                <textarea rows="5" class="form-control" [(ngModel)]="operationalNotes.commentText" (focusout)="saveComment(operationalNotes, 'operationalNotes')"></textarea>
            </div>
        </div>
        <div class="row">
            <div class="col text-end">
                <button class="btn btn-primary m-1" (click)="saveCustomer(false)" [disabled]="isSaving || isLocked">Save</button>
                <button class="btn btn-primary m-1" (click)="saveCustomer(true)" [disabled]="isSaving || isLocked">Save and Sync ERP</button>
            </div>
        </div>
        <div class="row" *ngIf="isLocked">
            <div class="col">
                <h2>* Customer Profile Locked</h2>
                <div>Profile edit for this customer is currently locked. Only notes can be updated.</div>
                <div><b>Locked By:</b> {{searchRecordLock.checkedOutByEmployeeName}}</div>
                <div><b>Date Locked:</b> {{searchRecordLock.dateCheckedOut | date:'medium'}}</div>
                <div><b>Lock Type:</b> {{searchRecordLock.recordLockTypeName}}</div>
                <div><b>Lock Source:</b> {{searchRecordLock.lockSource}}</div>
                <div class="float-right">
                    <button class="btn btn-danger" (click)="overrideRecordLock(searchRecordLock.recordID)">Override Lock</button>
                    <!--<button class="btn btn-primary" (click)="cancelOverride()">Cancel</button>-->
                </div>
            </div>
        </div>
    </div>
</div>

<!--<div [ngClass]="{'overlay_container_inside':isLocked}">
    <div class="overlay_message" *ngIf="isLocked">
        <h2>Customer Profile Locked</h2>
        <div>Profile edit for this customer is currently locked.</div>
        <div><b>Locked By:</b> {{searchRecordLock.checkedOutByEmployeeName}}</div>
        <div><b>Date Locked:</b> {{searchRecordLock.dateCheckedOut | date:'medium'}}</div>
        <div><b>Lock Type:</b> {{searchRecordLock.recordLockTypeName}}</div>
        <div><b>Lock Source:</b> {{searchRecordLock.lockSource}}</div>
        <div class="float-right">
            <button class="btn btn-danger" (click)="overrideRecordLock(searchRecordLock.recordID)">Override Lock</button>
            <button class="btn btn-primary" (click)="cancelOverride()">Cancel</button>
        </div>
    </div>
</div>-->
